import React, { useEffect } from 'react';
import { ChildComponentTitle } from 'components/Typography/styles';
import { ScrollableContainerOuterWithVerticalScrollbar } from './styles';

interface TranscriptionsProps {
  transcriptions: string[];
  interim: string | null;
}

const Transcriptions: React.FC<TranscriptionsProps> = ({ transcriptions, interim }) => {
  const scrollbarId = 'scroll-transcriptions';
  function scrollToBottom(): void {
    const container = document.getElementById(scrollbarId);
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  }

  useEffect(() => {
    scrollToBottom();
  }, [interim, transcriptions]);

  return (
    <>
      <ChildComponentTitle style={{ display: 'none' }}>Transcription</ChildComponentTitle>
      <ScrollableContainerOuterWithVerticalScrollbar id={scrollbarId}>
        {transcriptions.map((transcription, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <p key={`transcription-${index}`}>{transcription}</p>
        ))}
        {interim && (
          <p className="interim-transcription">{interim}</p>
        )}
      </ScrollableContainerOuterWithVerticalScrollbar>
    </>
  );
};

export default Transcriptions;
